import * as React from "react";
import IntlMessageFormat from "./auth-service-tools128.js";
import { MissingTranslationError, MessageFormatError } from "./auth-service-tools126.js";
import { invariant } from "./auth-service-tools130.js";

var __assign = globalThis && globalThis.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = globalThis && globalThis.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
};

function setTimeZoneInOptions(opts, timeZone) {
  return Object.keys(opts).reduce(function (all, k) {
    all[k] = __assign({
      timeZone
    }, opts[k]);
    return all;
  }, {});
}

function deepMergeOptions(opts1, opts2) {
  var keys = Object.keys(__assign(__assign({}, opts1), opts2));
  return keys.reduce(function (all, k) {
    all[k] = __assign(__assign({}, opts1[k] || {}), opts2[k] || {});
    return all;
  }, {});
}

function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
  if (!timeZone) {
    return f1;
  }

  var mfFormats = IntlMessageFormat.formats;
  return __assign(__assign(__assign({}, mfFormats), f1), {
    date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
    time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
  });
}

function prepareIntlMessageFormatHtmlOutput(chunks, shouldWrap) {
  return Array.isArray(chunks) && shouldWrap ? React.createElement.apply(React, __spreadArrays([React.Fragment, null], chunks)) : chunks;
}

function formatMessage(_a, state, messageDescriptor, values) {
  var locale = _a.locale,
      formats = _a.formats,
      messages = _a.messages,
      defaultLocale = _a.defaultLocale,
      defaultFormats = _a.defaultFormats,
      onError = _a.onError,
      timeZone = _a.timeZone,
      wrapRichTextChunksInFragment = _a.wrapRichTextChunksInFragment;

  if (messageDescriptor === void 0) {
    messageDescriptor = {
      id: ""
    };
  }

  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;
  invariant(!!id, "[React Intl] An `id` must be provided to format a message.");
  var message = messages && messages[String(id)];

  if (!values && message && typeof message === "string") {
    return message.replace(/'\{(.*?)\}'/gi, "{$1}");
  }

  formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
  defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);

  if (!message) {
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(new MissingTranslationError(messageDescriptor, locale));
    }

    if (defaultMessage) {
      try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
        return prepareIntlMessageFormatHtmlOutput(formatter.format(values), wrapRichTextChunksInFragment);
      } catch (e) {
        onError(new MessageFormatError('Error formatting default message for: "' + id + '", rendering default message verbatim', locale, messageDescriptor, e));
        return defaultMessage;
      }
    }

    return id;
  }

  try {
    var formatter = state.getMessageFormat(message, locale, formats, {
      formatters: state
    });
    return prepareIntlMessageFormatHtmlOutput(formatter.format(values), wrapRichTextChunksInFragment);
  } catch (e) {
    onError(new MessageFormatError('Error formatting message: "' + id + '", using ' + (defaultMessage ? "default message" : "id") + " as fallback.", locale, messageDescriptor, e));
  }

  if (defaultMessage) {
    try {
      var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
      return prepareIntlMessageFormatHtmlOutput(formatter.format(values), wrapRichTextChunksInFragment);
    } catch (e) {
      onError(new MessageFormatError('Error formatting the default message for: "' + id + '", rendering message verbatim', locale, messageDescriptor, e));
    }
  }

  return message || defaultMessage || id;
}

export { formatMessage };